import Pqp from "../../3x1010/Pqp.js";
import Bout from "../bout/Bout.js";
import Game from "../Game.js";
import Mob from "../screen/mobs/Mob.js";
import Screen from "../screen/Screen.js";
import Loggone from "../utils/Loggone.js";
import Cell from "./Cell.js";
import CellDesign from "./design/CellDesign.js";
import MazeDesign from "./design/MazeDesign.js";
import RoomDesign from "./design/RoomDesign.js";
import EscapeLogic from "./EscapeLogic.js";
import MazeConst from "./MazeConst.js";
import MazeRenderDebug from "./MazeRenderDebug.js";
import Room from "./Room.js";
import Saver from "./saver/Saver.js";

export default class Maze {
	constructor(initer) {
		this.initer = initer;
		this.target = initer.target;
		this.rooms = new Array();
		this.roomsExits = new Array();
		this.deadEnds = new Array();
		this.maze = new Array();
		this.callback = initer.eventsHandler;
		this.solution = undefined;
		this.verbose = initer.verbose;
		this.statics = new Array();
		this.fov = initer.fov;
		//this.fovRadius = initer.fovRadius;
		this.torches = new Array();
		this.styler = initer.styler;
		this.prefabric = initer.prefabric;
		this.pre = true;
		this.spikes = new Array();
		this.nUnreachable = 0
		this.nUnreachableCells = 0
		if (!initer.prefabric) {
			this.prefabric = null;
			this.pre = false;
		}

		if (Pqp.isNullOrEmpty(this.verbose)) {
			this.verbose = true;
		}
		this.POI = null;
		this.POIdistances = null;

		Maze.ID_POI = 0;
		CellDesign.IDS = 0;
		Cell.IDS = 0;
		Mob.ID = 0;

	}

	destroy() {
		this.rooms = new Array();
		this.roomsExits = new Array();
		this.deadEnds = new Array();
		this.maze = new Array();
	}

	init(alreadyDesigned = null) {
		this.build(alreadyDesigned);
	}

	build(alreadyDesigned = null) {
		this.designMaze();
	}

	isPre() {
		return this.pre;
	}

	designMaze() {
		RoomDesign.ID = 0;
		// Crea il modello
		this.mazeDesign = new MazeDesign(this.initer, this.designMazeEventsHandler.bind(this));
		this.mazeDesign.init();
		//console.log(this.mazeDesign)
	}

	designMazeEventsHandler(e) {
		if (e.type === MazeDesign.EVENT_CREATING_ROOM) {
			e.type = Maze.EVENT_CREATING_ROOM;
			this.dispatch(e);
		}
		if (e.type === MazeDesign.EVENT_CREATE_PATH_BLOCK) {
			e.type = Maze.EVENT_CREATE_PATH_BLOCK;
			this.dispatch(e);
		}
		if (e.type === MazeDesign.EVENT_PATH_CREATED) {
			e.type = Maze.EVENT_PATH_CREATED;
			this.dispatch(e);
			this.mazeDesigned();
			this.mazeDesign.print();
		}

	}

	mazeDesigned() {
		// Il modello è pronto, lo espande
		this.retention();

		// Setta il core delle room
		this.setCoreRooms();
	}

	retention() {
		// Lo espande
		this.maze = new Array();

		let design = this.mazeDesign.maze;
		// Bordo alto
		this.maze.push(new Array())
		for (let x = 0; x < this.mazeDesign.cols * 2 + 1; x++) {
			let cell = new Cell(this, Cell.TYPE_WALL, CellDesign.NOT_BELONG_TO_A_ROOM);
			this.maze[this.maze.length - 1].push(cell);
		}

		// Tutte le celle
		for (let row = 0; row < this.mazeDesign.rows; row++) {
			this.maze.push(new Array(new Cell(this, Cell.TYPE_WALL, CellDesign.NOT_BELONG_TO_A_ROOM)));
			for (let col = 0; col < this.mazeDesign.cols; col++) {
				let cellDesign = design[row][col];
				let cell = new Cell(this, Cell.TYPE_EMPTY, cellDesign.room, cellDesign.start, cellDesign.end);
				this.maze[this.maze.length - 1].push(cell);
				if (cellDesign.hasWall(CellDesign.WALL_E)) {
					cell = new Cell(this, Cell.TYPE_WALL, cellDesign.room);
				} else {
					cell = new Cell(this, Cell.TYPE_EMPTY, cellDesign.room);
				}
				this.maze[this.maze.length - 1].push(cell);
			}
			this.maze.push(new Array(new Cell(this, Cell.TYPE_WALL, CellDesign.NOT_BELONG_TO_A_ROOM)));
			for (let col = 0; col < this.mazeDesign.cols; col++) {
				let cellDesign = design[row][col];
				let cell;
				if (cellDesign.hasWall(CellDesign.WALL_S)) {
					cell = new Cell(this, Cell.TYPE_WALL, cellDesign.room);
					this.maze[this.maze.length - 1].push(cell);
				} else {
					cell = new Cell(this, Cell.TYPE_EMPTY, cellDesign.room);
					this.maze[this.maze.length - 1].push(cell);
				}
				cell = new Cell(this, Cell.TYPE_WALL, cellDesign.room);
				this.maze[this.maze.length - 1].push(cell);

			}
		}

		// Numeri corretti di row e col 
		for (let row = 0; row < this.maze.length; row++) {
			for (let col = 0; col < this.maze[row].length; col++) {
				let cell = this.maze[row][col];
				cell.row = row;
				cell.col = col;
			}
		}
		this.rows = this.maze.length;
		this.cols = this.maze[0].length;
	}

	setCoreRooms() {
		this.iterator = 0;
		this.setNextCoreRoom();
	}

	setNextCoreRoom() {
		let rooms = this.mazeDesign.rooms;
		if (this.iterator < rooms.length) {
			this.dispatch({ type: Maze.EVENT_CHECKING_ROOM, data: { iterations: this.iterator, cols: this.cols, rows: this.rows } });
			let roomDesign = rooms[this.iterator];
			this.setSingleCoreRoom(roomDesign, this.iterator);
			this.iterator++
		} else {
			this.coreRoomsSet();
		}
	}


	setSingleCoreRoom(roomDesign, roomIndex) {
		// Setta il core delle room
		let room = new Room(roomDesign.id, roomDesign.type, roomDesign.w * 2 - 1, roomDesign.h * 2 - 1, roomDesign.secret, roomIndex);
		this.rooms.push(room);
		let cellsCollection = new Array();
		let cv = 0;
		let lInc = false;
		for (let row = 0; row < this.rows; row++) {
			let cx = 0;
			for (let col = 0; col < this.cols; col++) {
				let cell = this.maze[row][col];
				if (cell.room === roomDesign.id) {
					lInc = true;
					let lOk = true;
					if (cx < roomDesign.w * 2 - 1) {
						cx++;

					} else {
						cell.room = CellDesign.NOT_BELONG_TO_A_ROOM;
						lOk = false;
					}
					if (!(cv < roomDesign.h * 2 - 1)) {
						cell.room = CellDesign.NOT_BELONG_TO_A_ROOM;
						lOk = false;
					}

					if (lOk) {
						cellsCollection.push(cell);
					}
				}
			}
			if (lInc) {
				cv++;
			}
		}
		room.init(cellsCollection);
		requestAnimationFrame(this.setNextCoreRoom.bind(this));
	}


	coreRoomsSet() {
		if (!this.isPre()) {
			this.fixRoomWalls();
		} else {
			for (let row = 0; row < this.rows; row++) {
				for (let col = 0; col < this.cols; col++) {
					let cell = this.maze[row][col];
					if (cell.start) {
						cell.start = false;
					}
				}
			}

			this.startCell = Saver.getFromMatrix(this.prefabric.startCell, this.maze);
			this.startCell.type = Cell.TYPE_EMPTY;
			this.startCell.start = true;


			this.endCell = Saver.getFromMatrix(this.prefabric.endCell, this.maze);
			this.endCell.type = Cell.TYPE_EMPTY;
			this.endCell.end = true;




			this.fixRoomWalls();
		}
	}

	fixRoomWalls() {
		this.iterator = 0;
		this.fixNextRow();
	}

	fixNextRow() {
		if (this.iterator < this.rows) {
			this.dispatch({ type: Maze.EVENT_FIXING_ROOM_WALLS, data: { iterations: this.iterator, cols: this.cols, rows: this.rows } });
			this.fixRow(this.iterator)
			this.iterator++
		} else {
			this.roomWallsFixed();
		}
	}
	fixRow(row) {
		// Aggiusta i muri interni delle room 
		//for (let row = 0; row < this.rows; row++) {
		for (let col = 0; col < this.cols; col++) {
			let cell = this.maze[row][col];
			if (cell.isRoom()) {
				if (cell.isWall()) {
					let neighbors = this.getNeighbors(cell);
					if (neighbors.length == 4) {
						let removeWall = true;
						for (let x = 0; x < neighbors.length; x++) {
							if (neighbors[x].isWall()) {
								removeWall = false;
								break;
							}
						}
						if (removeWall) {
							cell.type = Cell.TYPE_EMPTY;
							if (!this.isPre()) {
								cell.column = 0;
								let room = this.getRoomById(cell.room);
								if (room.isHallway()) {
									let n = Pqp.rnd(4);
									if (n === 0) {
										this.statics.push({ type: Maze.STATIC_TYPE_COLUMN, cell: cell });
										cell.column = 1;
									} else if (n === 1) {
										this.statics.push({ type: Maze.STATIC_TYPE_COLUMN, cell: cell });
										cell.column = 2;
									}
								}
							} else {
								for (let x = 0; x < this.prefabric.columns.length; x++) {
									let o = this.prefabric.columns[x];
									if (o.cell == cell.id) {
										//console.log(cell)
										this.statics.push({ type: Maze.STATIC_TYPE_COLUMN, cell: cell });
										cell.column = o.column;
										break;
									}
								}
							}
						}
					}
				}
			}
		}
		//}

		requestAnimationFrame(this.fixNextRow.bind(this));

	}


	roomWallsFixed() {
		if (!this.isPre()) {
			this.setUnreachableCellsAsWalls();
		} else {
			for (let x = 0; x < this.prefabric.secretRooms.length; x++) {
				let room = this.getRoomById(this.prefabric.secretRooms[x]);
				room.secret = true;
			}

			//this.findRoomsDoors();
			this.moveRoomWalls();
		}
	}


	setUnreachableCellsAsWalls() {
		this.iterator = 0;
		this.setUnreachableCellsAsWallsNextRow();
	}

	setUnreachableCellsAsWallsNextRow() {
		if (this.iterator < this.rows) {
			this.dispatch({ type: Maze.EVENT_SETTING_UNREACHABLE_CELLS_AS_WALL, data: { iterations: this.iterator, cols: this.cols, rows: this.rows } });
			this.setUnreachableCellsAsWallsRow(this.iterator)
			this.iterator++
		} else {
			this.setUnreachableCellsAsWallsDone();
		}
	}
	setUnreachableCellsAsWallsRow(row) {
		// Setta come muri i punti irraggiungibili
		//for (let row = 0; row < this.rows; row++) {
		for (let col = 0; col < this.cols; col++) {
			let cell = this.maze[row][col];
			if (!cell.isWall()) {
				let neighbors = this.getNeighbors(cell);
				let lTransform = true;
				for (let x = 0; x < neighbors.length; x++) {
					if (!neighbors[x].isWall()) {
						lTransform = false;
						break;
					}
				}
				if (lTransform) {
					this.nUnreachableCells++;
					cell.type = Cell.TYPE_WALL;
				}
			}
		}
		//}
		requestAnimationFrame(this.setUnreachableCellsAsWallsNextRow.bind(this));
	}

	setUnreachableCellsAsWallsDone() {
		this.checkUnreachableRooms()

	}



	checkUnreachableRooms() {
		this.iterator = 0;
		this.tmpRooms = new Array();
		this.checkNextUnreachableRooms();
	}

	checkNextUnreachableRooms() {
		let rooms = this.rooms;
		if (this.iterator < rooms.length) {
			this.dispatch({ type: Maze.EVENT_CHECK_FOR_UNREACHABLE_ROOMS, data: { iterations: this.iterator, cols: this.cols, rows: this.rows } });
			let room = rooms[this.iterator];
			this.checkSingleUnreachableRooms(room);
			this.iterator++
		} else {
			this.rooms = this.tmpRooms;
			this.checkUnreachableRoomsDone();
		}
	}



	checkSingleUnreachableRooms(room) {
		// Controlla se ci sono stanze irraggiungibili
		//let tmp = new Array();
		//for (let x = 0; x < this.rooms.length; x++) {
		//let room = this.rooms[x];
		let borders = room.getBorderCells();
		let lUnreachable = true;
		// tutti i bordi confinano all'esterno solo con muri
		for (let y = 0; y < borders.length; y++) {
			let cell = borders[y];

			if (cell.colRoom === 0) {
				let w = this.getNearbyCell(cell, Maze.DIR_W);
				if (!w.isWall()) {
					lUnreachable = false;
					break;
				}
			}

			if (cell.colRoom === room.w - 1) {
				let e = this.getNearbyCell(cell, Maze.DIR_E);
				if (!e.isWall()) {
					lUnreachable = false;
					break;
				}
			}


			if (cell.rowRoom === 0) {
				let n = this.getNearbyCell(cell, Maze.DIR_N);
				if (!n.isWall()) {
					lUnreachable = false;
					break;
				}
			}

			if (cell.rowRoom === room.h - 1) {
				let s = this.getNearbyCell(cell, Maze.DIR_S);
				if (!s.isWall()) {
					lUnreachable = false;
					break;
				}

			}
		}
		if (lUnreachable) {
			this.log("Room " + room.id + " of " + room.w + "x" + room.h + " unreachable, looking for secret passage...");
			if (!this.transformInSecretRoom(room)) {
				room.destroyBecauseUnreachable();
				this.log("Destroyed the room!");
				this.nUnreachable++;
			} else {
				this.tmpRooms.push(room);
			}
		} else {
			this.tmpRooms.push(room);
		}
		//}
		//this.rooms = tmp;
		requestAnimationFrame(this.checkNextUnreachableRooms.bind(this));


	}

	transformInSecretRoom(room) {
		let borders = room.getBorderCells();
		borders = Pqp.shuffle(borders);
		let lCondExit = false;
		let fuse = 0;
		let fuseWall = 0;
		let cell
		let lFoundWall = false;
		let lRet = false;
		//console.log(borders)
		while (!lFoundWall) {

			lCondExit = false;
			while (!lCondExit) {
				//cell = borders[Pqp.rnd(borders.length - 1)];
				cell = borders.pop();
				if (cell) {
					if (!room.isCornerCell(cell)) {
						lCondExit = true;
					}
				} else {
					lCondExit = true;
				}
				fuse++;
				if (fuse > 50) {
					lCondExit = true;
				}
			}
			//console.log(room);
			//console.log(cell);
			if (cell) {
				let lOk = false;
				if (!lOk) {
					if (cell.colRoom === 0) {
						let w = this.getNearbyCell(cell, Maze.DIR_W);
						if (w) {
							w = this.getNearbyCell(w, Maze.DIR_W);
							if (w) {
								if (!w.isWall()) {
									w = this.getNearbyCell(cell, Maze.DIR_W);
									w.type = Cell.TYPE_EMPTY;
									cell = w;
									lOk = true;
								}
							}
						}
					}
				}

				if (!lOk) {
					if (cell.colRoom === room.w - 1) {
						let e = this.getNearbyCell(cell, Maze.DIR_E);
						if (e) {
							e = this.getNearbyCell(e, Maze.DIR_E);
							if (e) {
								if (!e.isWall()) {
									e = this.getNearbyCell(cell, Maze.DIR_E);
									e.type = Cell.TYPE_EMPTY;
									cell = e;
									lOk = true;
								}
							}
						}
					}
				}

				if (!lOk) {
					if (cell.rowRoom === 0) {
						let n = this.getNearbyCell(cell, Maze.DIR_N);
						if (n) {
							n = this.getNearbyCell(n, Maze.DIR_N);
							if (n) {
								if (!n.isWall()) {
									n = this.getNearbyCell(cell, Maze.DIR_N);
									n.type = Cell.TYPE_EMPTY;
									cell = n;
									lOk = true;
								}
							}
						}
					}
				}

				if (!lOk) {
					if (cell.rowRoom === room.h - 1) {
						let s = this.getNearbyCell(cell, Maze.DIR_S);
						if (s) {
							s = this.getNearbyCell(s, Maze.DIR_S);
							if (s) {
								if (!s.isWall()) {
									s = this.getNearbyCell(cell, Maze.DIR_S);
									s.type = Cell.TYPE_EMPTY;
									cell = s;
									lOk = true;
								}
							}
						}
					}
				}


				if (lOk) {
					lFoundWall = true;
					this.log("Found a secret passage!");
					let secretRooms = this.getSecretRooms();
					if (secretRooms.length < this.initer.secretRooms) {
						room.secret = true;
					} else {
						this.log("But there are too many secret rooms, converting to normal room!");
					}
					//console.log(cell)
					lRet = true;
				}

				fuseWall++;
				if (fuseWall > 50) {
					lFoundWall = true;
				}
			} else {
				lFoundWall = true;
			}

		}

		if (!lRet) {
			this.log("Can't find a passage!")
		}


		return lRet;
		//console.log(cell)
	}





	checkUnreachableRoomsDone() {
		this.checkIfSecretRoomsAreEnough();
		this.moveRoomWalls();
		//this.findRoomsDoors();
	}



	moveRoomWalls() {
		this.iterator = 0;
		this.checkNextMoveRoomWalls();
	}

	checkNextMoveRoomWalls() {
		let rooms = this.rooms;
		if (this.iterator < rooms.length) {
			this.dispatch({ type: Maze.EVENT_MOVE_ROOM_DOORS, data: { iterations: this.iterator, cols: this.cols, rows: this.rows } });
			let room = rooms[this.iterator];
			this.checkSingleMoveRoomWalls(room);
			this.iterator++
		} else {
			this.checkNextMoveRoomWallsDone();
		}
	}

	checkSingleMoveRoomWalls(room) {
		//console.log(room)
		let borders = room.getBorderCells();
		//console.log(borders)
		for (let x = 0; x < borders.length; x++) {
			let cell = borders[x];
			let swap0 = null;
			let swap1 = null;
			if (cell.rowRoom == 0) {
				let n = this.getNearbyCell(cell, Maze.DIR_N);
				if (n) {
					//if (!n.isWall()) {
					if ((!n.isWall()) && (!n.isRoomExit())) {
						//debugger
						if (cell.colRoom === 0) {
							let ne = this.getNearbyCell(n, Maze.DIR_NE);
							if (ne) {
								//if (!ne.isWall()) {
								if ((!ne.isWall()) && (!ne.isRoomExit())) {
									swap0 = this.getNearbyCell(n, Maze.DIR_E);
									swap1 = n;
								}
							}
						}
						if (cell.colRoom === room.w - 1) {
							let nw = this.getNearbyCell(n, Maze.DIR_NW);
							if (nw) {
								//if (!nw.isWall()) {
								if ((!nw.isWall()) && (!nw.isRoomExit())) {
									swap0 = this.getNearbyCell(n, Maze.DIR_W);
									swap1 = n;
								}
							}

						}
					}
				}

			} else if (cell.rowRoom === room.h - 1) {
				let s = this.getNearbyCell(cell, Maze.DIR_S);
				if (s) {
					//if (!s.isWall()) {
					if ((!s.isWall()) && (!s.isRoomExit())) {
						//debugger
						if (cell.colRoom === 0) {
							let se = this.getNearbyCell(s, Maze.DIR_SE);
							if (se) {
								//if (!se.isWall()) {
								if ((!se.isWall()) && (!se.isRoomExit())) {
									swap0 = this.getNearbyCell(s, Maze.DIR_E);
									swap1 = s;
								}
							}
						}
						if (cell.colRoom === room.w - 1) {
							let sw = this.getNearbyCell(s, Maze.DIR_SW);
							if (sw) {
								//if (!sw.isWall()) {
								if ((!sw.isWall()) && (!sw.isRoomExit())) {
									swap0 = this.getNearbyCell(s, Maze.DIR_W);
									swap1 = s;
								}
							}

						}
					}
				}
			}

			if (swap0 && swap1) {
				swap0.type = Cell.TYPE_EMPTY;
				swap1.type = Cell.TYPE_WALL;
			}
		}

		requestAnimationFrame(this.checkNextMoveRoomWalls.bind(this));
	}


	checkNextMoveRoomWallsDone() {
		this.findRoomsDoors();
	}


	checkIfSecretRoomsAreEnough() {
		let quanti = this.getSecretRooms().length;
		if (quanti < this.initer.secretRooms) {
			let fatti = quanti;
			let rooms = this.rooms.slice();
			rooms = Pqp.shuffle(rooms);
			for (let x = 0; x < rooms.length; x++) {
				if (!rooms[x].isSecret()) {
					if (rooms[x].type === MazeConst.ROOM_TYPE_ONE_EXIT) {
						rooms[x].secret = true;
						fatti++;
					}
				}
				if (fatti === this.initer.secretRooms) {
					break;
				}
			}
		}

	}


	findRoomsDoors() {
		if (!this.isPre()) {
			this.iterator = 0;
			this.findRoomsDoorsNextRow();
		} else {
			//console.log(this.prefabric)
			for (let x = 0; x < this.prefabric.roomsExits.length; x++) {
				let cell = Saver.getFromMatrix(this.prefabric.roomsExits[x].id, this.maze);
				for (let y = 0; y < this.prefabric.roomsExits[x].roomExits.length; y++) {
					let room = this.getRoomById(this.prefabric.roomsExits[x].roomExits[y]);
					room.addExit(cell);
					cell.addAsRoomExit(room);
					cell.type = Cell.TYPE_EMPTY;
					this.statics.push({ type: Maze.STATIC_TYPE_DOOR, cell: cell });
				}
				this.roomsExits.push(cell);
			}
			this.findRoomsDoorsDone();
		}
	}

	findRoomsDoorsNextRow() {
		if (this.iterator < this.rows) {
			this.dispatch({ type: Maze.EVENT_LOOKING_FOR_ROOM_DOORS, data: { iterations: this.iterator, cols: this.cols, rows: this.rows } });
			this.findRoomsDoorsRow(this.iterator)
			this.iterator++
		} else {
			this.findRoomsDoorsDone();
		}
	}
	findRoomsDoorsRow(row) {
		// Cerca le porte delle stanze non hallway
		//for (let row = 0; row < this.rows; row++) {
		for (let col = 0; col < this.cols; col++) {
			let cell = this.maze[row][col];
			if (!cell.isRoom()) {
				if (!cell.isWall()) {
					let neighbors = this.getNeighbors(cell);
					for (let x = 0; x < neighbors.length; x++) {
						let nearCell = neighbors[x];
						//if (nearCell.room !== CellDesign.NOT_BELONG_TO_A_ROOM) {
						if (nearCell.isRoom()) {
							let room = this.getRoomById(nearCell.room);
							//console.log(room)
							if (room.type !== MazeConst.ROOM_TYPE_HALLWAY) {
								room.addExit(cell);
								this.roomsExits.push(cell);
								this.statics.push({ type: Maze.STATIC_TYPE_DOOR, cell: cell });
								cell.addAsRoomExit(room);
							}
						}
					}
				}
			}
		}
		//}
		requestAnimationFrame(this.findRoomsDoorsNextRow.bind(this));

	}

	findRoomsDoorsDone() {
		if (!this.isPre()) {
			this.setStartCell();
			this.findFarBorderCellWithDijkstra(this.startCell)
		} else {
			this.findDeadEnds();
		}
	}


	setStartCell() {
		// 
		for (let row = 0; row < this.rows; row++) {
			for (let col = 0; col < this.cols; col++) {
				let cell = this.maze[row][col];
				if (cell.start) {
					cell.start = false;
					let newCell = null;
					if (cell.row === 1) {
						newCell = this.getNearbyCell(cell, Maze.DIR_N);
					} else if (cell.col === 1) {
						newCell = this.getNearbyCell(cell, Maze.DIR_W);
					} else if (cell.row === this.rows - 2) {
						newCell = this.getNearbyCell(cell, Maze.DIR_S);
					} else if (cell.col === this.cols - 2) {
						newCell = this.getNearbyCell(cell, Maze.DIR_E);
					}
					if (newCell) {
						newCell.type = Cell.TYPE_EMPTY;
						newCell.start = true;
						this.startCell = newCell;
					} else {
						cell.start = true;
						this.startCell = cell;
					}
					return;
				}
			}
		}
	}

	findFarBorderCellWithDijkstra(cell) {
		let queue = new Array();
		for (let row = 0; row < this.rows; row++) {
			for (let col = 0; col < this.cols; col++) {
				if (this.maze[row][col].isWall()) {
					this.maze[row][col].distance = -1;
				} else {
					if (this.maze[row][col].id !== cell.id) {
						this.maze[row][col].distance = MazeConst.INFINITE_DISTANCE;
						queue.push(this.maze[row][col]);
					}
				}
			}
		}
		cell.distance = 0;
		//queue.unshift(cell);
		queue.push(cell);
		this.queue = queue;
		this.nextFindFarBorderCellWithDijkstra()
	}


	pathFind(start, end, callback) {
		//console.log(start)
		//console.log(end)
		// Azzera il pathIndex
		let queue = new Array();
		for (let row = 0; row < this.rows; row++) {
			for (let col = 0; col < this.cols; col++) {
				if (this.maze[row][col].isWall()) {
					this.maze[row][col].pathIndex = -1;
					this.maze[row][col].previous = null;
				} else {
					if (this.maze[row][col].id !== start.id) {
						this.maze[row][col].pathIndex = MazeConst.INFINITE_DISTANCE;
						this.maze[row][col].previous = null;
						queue.push(this.maze[row][col]);
					}
				}
			}
		}
		start.pathIndex = 0;
		//queue.unshift(start);
		queue.push(start);
		this.pathFindBlock(start, end, queue, callback);
	}





	nextFindFarBorderCellWithDijkstra() {
		let lCondExit = false;
		let fuse = 0;
		let lOkay = false;

		while (!lCondExit) {
			let cell = this.getCellWithMinorDistance(this.queue, "distance")
			let validNeighbors = this.getValidNeighbors(cell);
			let toRem = [];
			let toAdd = [];
			for (let x = 0; x < validNeighbors.length; x++) {
				let cellNear = validNeighbors[x];
				let alt = cell.distance + 1;
				if (alt < cellNear.distance) {
					cellNear.distance = alt;
					toRem.push(this.findCellNearIndex(cellNear, this.queue));
					toAdd.push(cellNear);
					//console.log(cellNear.id , this.queue.slice()); 
				}
			}

			toRem.sort(function (a, b) {
				return b - a;
			});

			/*
			Loggone.log("Prima");
			for (let x = 0; x < this.queue.length; x++) {
				Loggone.log(this.queue[x].distance == 999999 ? "," : this.queue[x].distance + ",", true);
			}
			Loggone.log("");*/

			for (let x = 0; x < toRem.length; x++) {
				//Loggone.log("Rimuovo pos: " + toRem[x]);
				this.queue.splice(toRem[x], 1);
			}
			/*Loggone.log("Dopo rem");
			for (let x = 0; x < this.queue.length; x++) {
				Loggone.log(this.queue[x].distance == 999999 ? "," : this.queue[x].distance + ",", true);
			}
			Loggone.log("");*/

			for (let x = 0; x < toAdd.length; x++) {
				this.addOrdered(toAdd[x], this.queue, "distance");
			}
			/*Loggone.log("Dopo add");
			for (let x = 0; x < this.queue.length; x++) {
				Loggone.log(this.queue[x].distance == 999999 ? "," : this.queue[x].distance + ",", true);
			}
			Loggone.log("");*/

			if (this.queue.length === 0) {
				lOkay = true;
				lCondExit = true;
			}
			fuse++;
			if (fuse > MazeConst.FUSE_DIJKSTRA) {
				lCondExit = true;
			}
		}

		if (!lOkay) {
			this.dispatch({ type: Maze.EVENT_DIJKSTRA, data: { lasts: this.queue.length, cols: this.cols, rows: this.rows } });
			requestAnimationFrame(this.nextFindFarBorderCellWithDijkstra.bind(this));
		} else {
			//Loggone.show();
			this.dispatch({ type: Maze.EVENT_DIJKSTRA_COMPLETED, data: { lasts: this.queue.length, cols: this.cols, rows: this.rows } });
			this.dijkstraCompleted();
		}

	}



	pathFindBlock(start, end, queue, callback) {

		let lCondExit = false;
		let fuse = 0;
		let cellNear
		let lOkay = false;
		while (!lCondExit) {

			let cell = this.getCellWithMinorDistance(queue, "pathIndex");
			let validNeighbors = this.getValidNeighbors(cell);
			let toRem = [];
			let toAdd = [];
			for (let x = 0; x < validNeighbors.length; x++) {
				cellNear = validNeighbors[x];
				let alt = cell.pathIndex + 1;
				if (alt < cellNear.pathIndex) {
					cellNear.pathIndex = alt;
					cellNear.previous = cell;
					toRem.push(this.findCellNearIndex(cellNear, queue));
					toAdd.push(cellNear);
					if (cellNear.id === end.id) {
						lCondExit = true;
						break;
					}
				}
			}

			toRem.sort(function (a, b) {
				return b - a;
			});

			for (let x = 0; x < toRem.length; x++) {
				queue.splice(toRem[x], 1);
			}

			for (let x = 0; x < toAdd.length; x++) {
				this.addOrdered(toAdd[x], queue, "pathIndex");
			}

			if (queue.length === 0) {
				lOkay = true;
				lCondExit = true;
			}
			fuse++;
			if (fuse > MazeConst.FUSE_DIJKSTRA) {
				lCondExit = true;
			}
		}

		if (!lOkay) {
			this.dispatch({ type: Maze.EVENT_FINDING_PATH, data: { lasts: queue.length, cols: this.cols, rows: this.rows } });
			requestAnimationFrame(this.pathFindBlock.bind(this, start, end, queue, callback));
		} else {
			/*			for (let row = 0; row < this.rows; row++) {
							for (let col = 0; col < this.cols; col++) {
								let cmp = this.maze[row][col];
								if (cmp.previous) {
									console.log(cmp)
								}
			
							}
			
						}*/

			try {
				this.pathFound(start, end, callback);
			} catch (e) {
				if (!Game.PROD) {
					console.log(e)
					console.log("Error in computing!")
					callback.call(null, null);
				}
			}
		}

	}


	getDistanceBetweenCells(start, end) {

		let distance = 0;
		/*for (let row = 0; row < this.rows; row++) {
			for (let col = 0; col < this.cols; col++) {
				this.maze[row][col].pathIndex = -1;
			}
		}*/

		// Azzera il pathIndex
		let queue = new Array();
		for (let row = 0; row < this.rows; row++) {
			for (let col = 0; col < this.cols; col++) {
				if (this.maze[row][col].isWall()) {
					this.maze[row][col].pathIndex = -1;
				} else {
					if (this.maze[row][col].id !== start.id) {
						this.maze[row][col].pathIndex = MazeConst.INFINITE_DISTANCE;
						queue.push(this.maze[row][col]);
					}
				}
			}
		}
		start.pathIndex = 0;
		queue.push(start);

		let lCondExit = false;
		let fuse = 0;
		while (!lCondExit) {


			let cell = this.getCellWithMinorDistance(queue, "pathIndex")
			let validNeighbors = this.getValidNeighbors(cell);
			let toRem = [];
			let toAdd = [];
			for (let x = 0; x < validNeighbors.length; x++) {
				let cellNear = validNeighbors[x];
				let alt = cell.pathIndex + 1;
				if (alt < cellNear.pathIndex) {
					cellNear.pathIndex = alt;
					toRem.push(this.findCellNearIndex(cellNear, queue));
					toAdd.push(cellNear);
				}
				if (cellNear.id === end.id) {

					distance = cellNear.pathIndex;
					lCondExit = true;
					break;
				}
			}

			toRem.sort(function (a, b) {
				return b - a;
			});

			for (let x = 0; x < toRem.length; x++) {
				queue.splice(toRem[x], 1);
			}

			for (let x = 0; x < toAdd.length; x++) {
				this.addOrdered(toAdd[x], queue, "pathIndex");
			}

			if (queue.length === 0) {
				lCondExit = true;
			}
			fuse++;
			if (fuse > MazeConst.FUSE_FIND_PATH) {
				lCondExit = true;
			}
		}

		return distance + 1; // Parte da 0
	}

	pathFound(start, cell, callback) {
		let path = new Array();
		let lCondExit = false;
		let fuse = 0;

		while (!lCondExit) {
			let prev = cell.previous;
			path.unshift(cell);
			cell = prev;
			if (Pqp.isNullOrEmpty(cell)) {
				lCondExit = true;
			}
			if (cell.id === start.id) {
				lCondExit = true;
			}
			fuse++;
			if (fuse > MazeConst.FUSE_FIND_PATH) {
				lCondExit = true;
			}
		}
		this.dispatch({ type: Maze.EVENT_PATH_FOUND, data: { lasts: path.length, cols: this.cols, rows: this.rows } });

		if (callback) {
			callback.call(null, path);
		} else {
			console.log(path);
		}
	}


	findCellNearIndex(cell, queue) {
		/*for (let x = 0; x < queue.length; x++) {
			if (queue[x].id === cell.id) {
				return x;
			}
		}*/

		for (let x = queue.length - 1; x >= 0; x--) {
			if (queue[x].id === cell.id) {
				return x;
			}
		}

		return -1;
	}

	getCellWithMinorDistance(queue, prop) {
		//let cell = queue.shift();
		let cell = queue.pop();

		return cell;

		/*
		let min = -1;
		let quale = -1;
		for (let x = 0; x < queue.length; x++) {
			if (min === -1) {
				min = queue[x][prop];
				quale = x;
				Loggone.log(min + " --> " + quale);
				//window.loggone += min + " --> " + quale + "\n"

			} else {
				if (queue[x][prop] < min) {
					min = queue[x][prop];
					quale = x;
					//window.loggone += min + " --> " + quale + "\n"
					Loggone.log(min + " --> " + quale);
				}
			}
		}
		//window.loggone += "estraggo " + quale + " \n"
		Loggone.log("estraggo " + quale);
		//console.log(quale)
		let cell;
		if (quale == 0) {
			cell = queue.shift();
		} else {
			cell = queue.splice(quale, 1)[0]
		}

		for (let x = 0; x < queue.length; x++) {
			Loggone.log(queue[x].pathIndex == 999999 ? "," : queue[x].pathIndex + ",", true);
		}
		Loggone.log("");


		return cell;*/
	}

	/*
	addOrdered(el, arr, prop) {
		arr.splice(this.findLoc(el, arr, prop) + 1, 0, el);
		return arr;
	}

	findLoc(el, arr, prop, st, en) {
		st = st || 0;
		en = en || arr.length;
		for (let i = 0; i < arr.length; i++) {
			if (arr[i][prop] > el[prop])
				return i - 1;
		}
		return en;
	}*/

	addOrdered(el, arr, prop) {
		/*
		let n = 0;
		for (let x = 0; x < arr.length; x++) {
			if (arr[x][prop] > el[prop]) {
				n = x;
				break;
			}
		}
		arr.splice(n, 0, el);*/

		let n = 0;
		for (let x = arr.length - 1; x >= 0; x--) {
			if (arr[x][prop] > el[prop]) {
				n = x;
				break;
			}
		}
		arr.splice(n + 1, 0, el);
	}

	/*addOrdered(el, arr, prop) {
		arr.splice(this.findLoc(el, arr, prop) + 1, 0, el);
		return arr;
	}

	findLoc(el, arr, prop, st, en) {
		st = st || 0;
		en = en || arr.length;
		var pivot = parseInt(st + (en - st) / 2, 10);
		if (en - st <= 1 || arr[pivot].prop === el.prop) return pivot;
		if (arr[pivot].prop > el.prop) {
			return this.findLoc(el, arr, prop,pivot, en);
		} else {
			return this.findLoc(el, arr, st, prop, pivot);
		}
	}*/



	getValidNeighbors(cell) {
		let neighbors = new Array();

		//console.log(cell)
		let n = this.getNearbyCell(cell, Maze.DIR_N);
		let w = this.getNearbyCell(cell, Maze.DIR_W);
		let s = this.getNearbyCell(cell, Maze.DIR_S);
		let e = this.getNearbyCell(cell, Maze.DIR_E);

		if (n) {
			if (!n.isWall()) {
				neighbors.push(n);
			}
		}
		if (w) {
			if (!w.isWall()) {
				neighbors.push(w);
			}
		}
		if (s) {
			if (!s.isWall()) {
				neighbors.push(s);
			}
		}
		if (e) {
			if (!e.isWall()) {
				neighbors.push(e);
			}
		}
		return neighbors;
	}

	dijkstraCompleted() {
		this.choseEndCell(true);
		this.findDeadEnds();
	}

	choseEndCell(lExternal = false) {
		let a;
		if (lExternal) {
			a = this.getExternalCells();
		} else {
			a = this.getAllValidCells();
		}

		let cell = null;
		let distance = 0;
		for (let x = 0; x < a.length; x++) {
			if (a[x].distance > distance) {
				cell = a[x];
				distance = a[x].distance;
			}
		}

		let newCell = null;
		if (cell.row === 1) {
			newCell = this.getNearbyCell(cell, Maze.DIR_N);
		} else if (cell.col === 1) {
			newCell = this.getNearbyCell(cell, Maze.DIR_W);
		} else if (cell.row === this.rows - 2) {
			newCell = this.getNearbyCell(cell, Maze.DIR_S);
		} else if (cell.col === this.cols - 2) {
			newCell = this.getNearbyCell(cell, Maze.DIR_E);
		}
		if (newCell) {
			newCell.type = Cell.TYPE_EMPTY;
			newCell.end = true;
			newCell.distance = cell.distance + 1;
			this.endCell = newCell;
		} else {
			cell.end = true;
			this.endCell = cell;
		}

	}


	findDeadEnds() {
		this.iterator = 0;
		this.findDeadEndsNextRow();
	}

	findDeadEndsNextRow() {
		if (this.iterator < this.rows) {
			this.dispatch({ type: Maze.EVENT_LOOKING_FOR_DEAD_ENDS, data: { iterations: this.iterator, cols: this.cols, rows: this.rows } });
			this.findDeadEndsRow(this.iterator)
			this.iterator++
		} else {
			this.findDeadEndsDone();
		}
	}

	findDeadEndsRow(row) {
		// Cerca le porte delle stanze non hallway
		//for (let row = 0; row < this.rows; row++) {
		for (let col = 0; col < this.cols; col++) {
			let cell = this.maze[row][col];
			let deadEnd = false;
			if (!cell.isWall()) {
				let neighbors = this.getNeighbors(cell);
				if (neighbors.length === 4) {
					let walls = 0;
					for (let x = 0; x < neighbors.length; x++) {
						if (neighbors[x].isWall()) {
							walls++;
						}
					}
					if (walls === 3) {
						deadEnd = true;
						this.deadEnds.push(cell);
						let n = this.getNearbyCell(cell, Maze.DIR_N);
						if (n) {
							if (n.isWall()) {
								let e = this.getNearbyCell(n, Maze.DIR_E);
								let w = this.getNearbyCell(n, Maze.DIR_W);
								if ((!e.isHorizontalDoor()) && (!w.isHorizontalDoor())) {
									this.torches.push(n);
								}
							}
						}

					}
				}
			}
			cell.deadEnd = deadEnd;
		}
		//}
		requestAnimationFrame(this.findDeadEndsNextRow.bind(this));
	}


	findDeadEndsDone() {
		// Controlla l'uscita che non abbia una porta o qualche cagata di fianco
		if (this.endCell.row === 0) {
			let s = this.getNearbyCell(this.endCell, Maze.DIR_S);
			if (s.isRoomExit()) {
				let w = this.getNearbyCell(s, Maze.DIR_W);
				if (!w.isWall()) {
					this.endCell.type = Cell.TYPE_WALL;
					this.endCell.end = false;
					let n = this.getNearbyCell(w, Maze.DIR_N);
					this.endCell = n
					this.endCell.type = Cell.TYPE_EMPTY;
					this.endCell.end = true;
				} else {
					let e = this.getNearbyCell(s, Maze.DIR_E);
					if (!e.isWall()) {
						this.endCell.type = Cell.TYPE_WALL;
						this.endCell.end = false;
						let n = this.getNearbyCell(e, Maze.DIR_N);
						this.endCell = n
						this.endCell.type = Cell.TYPE_EMPTY;
						this.endCell.end = true;
					}
				}
			}
		} else if (this.endCell.row === this.rows - 1) {
			let n = this.getNearbyCell(this.endCell, Maze.DIR_N);
			if (n.isRoomExit()) {
				let w = this.getNearbyCell(n, Maze.DIR_W);
				if (!w.isWall()) {
					this.endCell.type = Cell.TYPE_WALL;
					this.endCell.end = false;
					let s = this.getNearbyCell(w, Maze.DIR_S);
					this.endCell = s
					this.endCell.type = Cell.TYPE_EMPTY;
					this.endCell.end = true;
				} else {
					let e = this.getNearbyCell(s, Maze.DIR_E);
					if (!e.isWall()) {
						this.endCell.type = Cell.TYPE_WALL;
						this.endCell.end = false;
						let s = this.getNearbyCell(e, Maze.DIR_S);
						this.endCell = s
						this.endCell.type = Cell.TYPE_EMPTY;
						this.endCell.end = true;
					}
				}
			}

		} else if (this.endCell.col === 0) {
			let e = this.getNearbyCell(this.endCell, Maze.DIR_E);
			if (e.isRoomExit()) {
				let n = this.getNearbyCell(e, Maze.DIR_N);
				if (!n.isWall()) {
					this.endCell.type = Cell.TYPE_WALL;
					this.endCell.end = false;
					let w = this.getNearbyCell(n, Maze.DIR_W);
					this.endCell = w
					this.endCell.type = Cell.TYPE_EMPTY;
					this.endCell.end = true;
				} else {
					let s = this.getNearbyCell(w, Maze.DIR_S);
					if (!s.isWall()) {
						this.endCell.type = Cell.TYPE_WALL;
						this.endCell.end = false;
						let w = this.getNearbyCell(s, Maze.DIR_W);
						this.endCell = w
						this.endCell.type = Cell.TYPE_EMPTY;
						this.endCell.end = true;
					}
				}
			}

		} else if (this.endCell.col === this.cols - 1) {
			let w = this.getNearbyCell(this.endCell, Maze.DIR_W);
			if (w.isRoomExit()) {
				let n = this.getNearbyCell(w, Maze.DIR_N);
				if (!n.isWall()) {
					this.endCell.type = Cell.TYPE_WALL;
					this.endCell.end = false;
					let e = this.getNearbyCell(n, Maze.DIR_E);
					this.endCell = e
					this.endCell.type = Cell.TYPE_EMPTY;
					this.endCell.end = true;
				} else {
					let s = this.getNearbyCell(w, Maze.DIR_S);
					if (!s.isWall()) {
						this.endCell.type = Cell.TYPE_WALL;
						this.endCell.end = false;
						let e = this.getNearbyCell(s, Maze.DIR_E);
						this.endCell = e
						this.endCell.type = Cell.TYPE_EMPTY;
						this.endCell.end = true;
					}
				}
			}
		}

		this.findSolution();
	}

	findSolution() {
		this.pathFind(this.startCell, this.endCell, this.gotSolution.bind(this));
	}

	gotSolution(path) {
		this.solution = path;

		let failed;
		if (!path) {
			failed = true;
		} else {
			failed = this.failureInbuildingMaze();
		}
		
		if (failed) {
			this.rebuild();
		} else {
			if (Game.DEBUG_NO_POI) {
				this.dispatch({ type: Maze.EVENT_MAZE_READY });
			} else {
				let det = Screen.that.featurer.getCurrentLevelDetails();
				if (det.poi === "true") {
					this.getPOIDistancesFromPOI();
				} else {
					this.addEscapeLogic();
				}
			}
		}
	}

	failureInbuildingMaze() {
		// Uscita non raggiungibile
		if (this.endCell.pathIndex === MazeConst.INFINITE_DISTANCE) {
			this.log("Maze failed because no reachable exit was found");

			return true;
		}
		if (this.rooms.length / this.initer.rooms.length < MazeConst.BUILD_FAILURE_PERCENTAGE) {
			this.log("Maze failed because too less rooms " + Math.floor(this.rooms.length / this.initer.rooms.length * 100) + "%");
			return true;
		}
		for (let x = 0; x < this.roomsExits.length; x++) {
			let cell = this.roomsExits[x];
			let lFail = false;
			let n = this.getNearbyCell(cell, Maze.DIR_N);
			if (n.isRoomExit()) {
				lFail = true;
			}
			let e = this.getNearbyCell(cell, Maze.DIR_E);
			if (e.isRoomExit()) {
				lFail = true;
			}
			let s = this.getNearbyCell(cell, Maze.DIR_S);
			if (s.isRoomExit()) {
				lFail = true;
			}
			let w = this.getNearbyCell(cell, Maze.DIR_W);
			if (w.isRoomExit()) {
				lFail = true;
			}
			if (lFail) {
				this.log("Maze failed because two rooms exits collides");
				return true;
			}

		}

		if (this.nUnreachable > 0) {
			this.log("Maze failed because room unreachable");
			return true;
		}
		if (this.nUnreachableCells > 0) {
			this.log("Maze failed because too many unreachable cells");
			return true;
		}

		if (this.getSecretRooms().length != this.initer.secretRooms) {
			this.log("Maze failed because there must be " + this.initer.secretRooms + " secret rooms but there are only " + this.getSecretRooms().length);
			let rooms = this.initer.rooms.slice();
			rooms = Pqp.shuffle(rooms);
			let single = 0
			for (let x = 0; x < rooms.length; x++) {
				if (rooms[x].type == MazeConst.ROOM_TYPE_ONE_EXIT) {
					single++;
				}
			}
			//let quanti = this.initer.secretRooms - single;
			let quanti = single;
			for (let x = 0; x < rooms.length; x++) {
				if (rooms[x].type !== MazeConst.ROOM_TYPE_ONE_EXIT) {
					if (quanti < this.initer.secretRooms) {
						quanti++;
						rooms[x].type = MazeConst.ROOM_TYPE_ONE_EXIT;
					}
				}
			}

			return true;
		}
		Bout.incStatistic(Bout.STAT_TORCHES_TOTAL, this.torches.length);
		return false;
	}


	getPOIDistancesFromPOI() {
		this.POI = this.getPOI();
		this.POIdistances = new Array();
		this.iterator = 0;
		requestAnimationFrame(this.nextGetPOIDistancesFromPOI.bind(this));
	}

	nextGetPOIDistancesFromPOI() {
		if (this.iterator < this.POI.length) {
			this.getSinglePOIDistancesFromPOI();
		} else {
			this.addEscapeLogic();
			//console.log(this.POIdistances);
		}
	}

	getSinglePOIDistancesFromPOI() {
		this.indexPOI = 0;
		requestAnimationFrame(this.nextGetSinglePOIDistancesFromPOI.bind(this));
	}

	nextGetSinglePOIDistancesFromPOI() {
		this.dispatch({ type: Maze.EVENT_COMPUTING_POI, data: { count: this.iterator * this.POI.length + this.indexPOI, total: this.POI.length * (this.POI.length) } });
		if (this.indexPOI < this.POI.length) {
			let poi0 = this.POI[this.iterator];
			let poi1 = this.POI[this.indexPOI];
			if (poi0.cell.id !== poi1.cell.id) {
				let lFound = false;
				for (let x = 0; x < this.POIdistances.length; x++) {
					if (((this.POIdistances[x].poi0.cell.id === poi0.cell.id) && (this.POIdistances[x].poi1.cell.id === poi1.cell.id)) || ((this.POIdistances[x].poi0.cell.id === poi1.cell.id) && (this.POIdistances[x].poi1.cell.id === poi0.cell.id))) {
						lFound = true;
						break;
					}
				}

				if (!lFound) {
					let dist = this.getDistanceBetweenCells(poi0.cell, poi1.cell);
					this.POIdistances.push({ poi0: poi0, poi1: poi1, distance: dist });
				}
				//console.log(dist);
			}
			this.indexPOI++;
			requestAnimationFrame(this.nextGetSinglePOIDistancesFromPOI.bind(this));
		} else {
			this.iterator++;
			requestAnimationFrame(this.nextGetPOIDistancesFromPOI.bind(this));
		}

	}

	getPOIFromType(type) {
		let ret = new Array();
		for (let x = 0; x < this.POI.length; x++) {
			if (this.POI[x].type === type) {
				ret.push(this.POI[x]);
			}
		}
		return ret;
	}


	getPOI() {
		let ret = new Array();
		ret.push({ id: "poi" + Maze.ID_POI++, cell: this.startCell, type: "start" });
		ret.push({ id: "poi" + Maze.ID_POI++, cell: this.endCell, type: "end" });
		for (let x = 0; x < this.rooms.length; x++) {
			ret.push({ id: "poi" + Maze.ID_POI++, cell: this.rooms[x].getCenterCell(), type: "room", room: this.rooms[x] });
		}
		return ret;
	}

	getPOIDistanceFrom(poi, filters = null) {
		let a = this.POIdistances;
		let ret = new Array();
		for (let x = 0; x < a.length; x++) {
			if ((a[x].poi0.id === poi.id) || (a[x].poi1.id === poi.id)) {
				let lOk = true;
				if (filters) {
					let type = a[x].poi0.id === poi.id ? a[x].poi1.type : a[x].poi1.type;
					//console.log(type)
					if (filters.indexOf(type) < 0) {
						lOk = false;
					}
				}
				if (lOk) {
					ret.push(a[x]);
				}
			}
		}
		return ret;
	}


	getRoomById(id) {
		for (let x = 0; x < this.rooms.length; x++) {
			if (this.rooms[x].id === id) {
				return this.rooms[x];
			}
		}
		return null;
	}

	getNeighbors(cell) {
		let ret = new Array();
		let n = this.getNearbyCell(cell, Maze.DIR_N);
		let w = this.getNearbyCell(cell, Maze.DIR_W);
		let s = this.getNearbyCell(cell, Maze.DIR_S);
		let e = this.getNearbyCell(cell, Maze.DIR_E);
		if (n) ret.push(n);
		if (w) ret.push(w);
		if (s) ret.push(s);
		if (e) ret.push(e);
		return ret;
	}

	getNearbyCell(cell, dir) {
		let newCell = null;
		let pos = this.getPosition(cell);
		pos = this.movePosition(pos, dir);
		newCell = this.getCell(pos);
		return newCell;
	}


	getPosition(cell) {
		return { row: cell.row, col: cell.col };
	}


	movePosition(pos, dir) {
		if (dir === MazeDesign.DIR_N) {
			pos.row -= 1;
		} else if (dir === MazeDesign.DIR_E) {
			pos.col += 1;
		} else if (dir === MazeDesign.DIR_S) {
			pos.row += 1;
		} else if (dir === MazeDesign.DIR_W) {
			pos.col -= 1;
		} else if (dir === MazeDesign.DIR_NW) {
			pos.row -= 1;
			pos.col -= 1;
		} else if (dir === MazeDesign.DIR_NE) {
			pos.row -= 1;
			pos.col += 1;
		} else if (dir === MazeDesign.DIR_SW) {
			pos.row += 1;
			pos.col -= 1;
		} else if (dir === MazeDesign.DIR_SE) {
			pos.row += 1;
			pos.col += 1;
		}
		return pos;
	}


	getCell(pos) {

		let cols = this.maze[pos.row];
		if (Pqp.isNullOrEmpty(cols)) {
			return null;
		}
		let cell = cols[pos.col];
		if (Pqp.isNullOrEmpty(cell)) {
			return null;
		}
		return cell;
	}

	getCellDirect(row, col) {
		let cols = this.maze[row];
		if (Pqp.isNullOrEmpty(cols)) {
			return null;
		}
		let cell = cols[col];
		if (Pqp.isNullOrEmpty(cell)) {
			return null;
		}
		return cell;
	}


	getExternalCells() {
		let ret = new Array();
		for (let row = 0; row < this.rows; row++) {
			for (let col = 0; col < this.cols; col++) {
				let cell = this.maze[row][col];
				if (!cell.isWall()) {
					if ((row === 1) || (col === 1) || (col === this.cols - 2) || (row === this.rows - 2)) {
						ret.push(cell)
					}
				}
			}
		}
		return ret;
	}

	getAllValidCells() {
		let ret = new Array();
		for (let row = 0; row < this.rows; row++) {
			for (let col = 0; col < this.cols; col++) {
				let cell = this.maze[row][col];
				if (!cell.isWall()) {
					ret.push(cell)
				}
			}
		}
		return ret;
	}





	getRoomExits(id) {
		let ret = new Array();
		let a = this.roomsExits;
		for (let x = 0; x < a.length; x++) {
			let b = a[x].roomExits;
			for (let y = 0; y < b.length; y++) {
				if (b[y].id == id) {
					ret.push(a[x]);
					break;
				}
			}
		}
		return ret;
	}


	print() {
		let s = ""
		for (let row = 0; row < this.rows; row++) {
			for (let col = 0; col < this.cols; col++) {
				let cell = this.maze[row][col];
				if (cell.isWall()) {
					s += "X";
				} else {
					s += " ";
				}
			}
			s += "\n"
		}
		console.log(s)
	}

	getSecretRooms() {
		let ret = new Array();
		for (let x = 0; x < this.rooms.length; x++) {
			let room = this.rooms[x];
			if (room.isSecret()) {
				ret.push(room);
			}
		}
		return ret;
	}

	rebuild() {
		this.log("---REBUILD---")
		//this.destroy();
		//this.build();
		this.dispatch({ type: Maze.EVENT_NEED_REBUILD })
	}

	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}

	log(value) {
		if (!Game.PROD) {
			if (this.verbose) {
				console.log(value);
			}
		}
	}

	getWallPattern(cell) {
		let bits = [0, 0, 0, 0]
		let n = this.getNearbyCell(cell, Maze.DIR_N);
		let w = this.getNearbyCell(cell, Maze.DIR_W);
		let s = this.getNearbyCell(cell, Maze.DIR_S);
		let e = this.getNearbyCell(cell, Maze.DIR_E);
		if (n) {
			if (n.isWall() || n.isSecretExit()) {
				bits[0] = 1;
			}
		}
		if (e) {
			if (e.isWall() || e.isSecretExit()) {
				bits[1] = 1;
			}
		}
		if (s) {
			if (s.isWall() || s.isSecretExit()) {
				bits[2] = 1;
			}
		}
		if (w) {
			if (w.isWall() || w.isSecretExit()) {
				bits[3] = 1;
			}
		}
		let ret = ""
		for (let x = 0; x < bits.length; x++) {
			ret += bits[x];
		}
		return ret;
	}

	getCellsSubset(row0, col0, row1, col1) {
		let cells = new Array();
		for (let row = row0; row <= row1; row++) {
			for (let col = col0; col <= col1; col++) {
				let cell = this.getCellDirect(row, col);
				if (cell) {
					cells.push(cell);
				}
			}
		}
		return cells;
	}

	getCellsSubsetMatrix(row0, col0, row1, col1) {
		let cells = new Array();
		for (let row = row0; row <= row1; row++) {
			cells.push(new Array())
			for (let col = col0; col <= col1; col++) {
				let cell = this.getCellDirect(row, col);
				cells[cells.length - 1].push(cell);
			}
		}
		return cells;
	}


	getCellsAround(distance, cell) {
		let ret = new Array();
		//ret.push(cell)
		if (distance === 0) {
			let dirs = [Maze.DIR_N, Maze.DIR_W, Maze.DIR_E, Maze.DIR_S];
			for (let x = 0; x < dirs.length; x++) {
				let tmp = this.getNearbyCell(cell, dirs[x]);
				ret.push(tmp);
			}
			return ret;
		}
		if (distance === 1) {
			let dirs = [Maze.DIR_NW, Maze.DIR_NE, Maze.DIR_SW, Maze.DIR_SE];
			for (let x = 0; x < dirs.length; x++) {
				let tmp = this.getNearbyCell(cell, dirs[x]);
				ret.push(tmp);
			}
			return ret;
		}
		if (distance === 2) {
			let dirs = [Maze.DIR_NW, Maze.DIR_N, Maze.DIR_NE, Maze.DIR_W, Maze.DIR_E, Maze.DIR_SW, Maze.DIR_S, Maze.DIR_SE];
			for (let x = 0; x < dirs.length; x++) {
				let tmp = this.getNearbyCell(cell, dirs[x]);
				ret.push(tmp);
			}
			return ret;
		}
		if (distance === 3) {
			let rowStart = cell.row - 2;
			let colStart = cell.col - 2;
			for (let row = rowStart; row < rowStart + 5; row++) {
				for (let col = colStart; col < colStart + 5; col++) {
					if ((col === colStart) && (row === rowStart)) {
						ret.push(this.getCellDirect(row, col));
					} else if ((col === colStart) && (row === rowStart + 4)) {
						ret.push(this.getCellDirect(row, col));
					} else if ((col === colStart + 4) && (row === rowStart)) {
						ret.push(this.getCellDirect(row, col));
					} else if ((col === colStart + 4) && (row === rowStart + 4)) {
						ret.push(this.getCellDirect(row, col));
					} else {
						if ((col === colStart) || (col === colStart + 4)) {
							ret.push(this.getCellDirect(row, col));
						}
						if ((row === rowStart) || (row === rowStart + 4)) {
							ret.push(this.getCellDirect(row, col));
						}
					}
				}
			}
			return ret;
		}
		if (distance === 4) {
			let rowStart = cell.row - 3;
			let colStart = cell.col - 3;
			for (let row = rowStart; row < rowStart + 7; row++) {
				for (let col = colStart; col < colStart + 7; col++) {
					if ((col === colStart) && (row === rowStart)) {
						ret.push(this.getCellDirect(row, col));
					} else if ((col === colStart) && (row === rowStart + 6)) {
						ret.push(this.getCellDirect(row, col));
					} else if ((col === colStart + 6) && (row === rowStart)) {
						ret.push(this.getCellDirect(row, col));
					} else if ((col === colStart + 6) && (row === rowStart + 6)) {
						ret.push(this.getCellDirect(row, col));
					} else {
						if ((col === colStart) || (col === colStart + 6)) {
							ret.push(this.getCellDirect(row, col));
						}
						if ((row === rowStart) || (row === rowStart + 6)) {
							ret.push(this.getCellDirect(row, col));
						}
					}
				}
			}
			return ret;
		}

		return ret;
	}

	getWhatBorderTheCellBelongsTo(cell) {
		if (cell.row === 0) {
			return Maze.DIR_N;
		}
		if (cell.row === this.rows - 1) {
			return Maze.DIR_S;
		}
		if (cell.col === 0) {
			return Maze.DIR_W;
		}
		if (cell.col === this.cols - 1) {
			return Maze.DIR_E;
		}

		return null;
	}



	addEscapeLogic() {
		this.escapeLogic = new EscapeLogic(this);
		this.escapeLogic.init();

		this.dispatch({ type: Maze.EVENT_MAZE_READY });
	}

	hasFov() {
		return this.fov;
	}

	localPathFind(start, end, cellsBlock, callback) {
		// Azzera il pathIndex
		let queue = new Array();
		let prop = "cl" + Pqp.rnd(10000);
		//console.log(prop);
		//console.log(cellsBlock);
		for (let row = 0; row < cellsBlock.length; row++) {
			//console.log(cellsBlock[row])
			for (let col = 0; col < cellsBlock[0].length; col++) {
				let localCell = cellsBlock[row][col];
				if (localCell) {
					localCell[prop + "Row"] = row;
					localCell[prop + "Col"] = col;
				} else {
					localCell = new Cell(this, Cell.TYPE_WALL, CellDesign.NOT_BELONG_TO_A_ROOM);
					localCell[prop + "Row"] = row;
					localCell[prop + "Col"] = col;
					cellsBlock[row][col] = localCell;
				}

				if ((cellsBlock[row][col].isWall()) || (cellsBlock[row][col].isColumn()) || (cellsBlock[row][col].isChest())) {
					cellsBlock[row][col].pathIndex = -1;
					cellsBlock[row][col].previous = null;
				} else {
					if (cellsBlock[row][col].id !== start.id) {
						cellsBlock[row][col].pathIndex = MazeConst.INFINITE_DISTANCE;
						cellsBlock[row][col].previous = null;
						queue.push(cellsBlock[row][col]);
					}
				}
			}
		}
		//console.log(cellsBlock);

		start.pathIndex = 0;
		//queue.unshift(start);
		queue.push(start);
		this.localPathFindBlock(start, end, cellsBlock, prop, queue, callback);
	}

	localPathFindBlock(start, end, cellsBlock, prop, queue, callback) {

		let lCondExit = false;
		let fuse = 0;
		let cellNear
		let lOkay = false;
		while (!lCondExit) {

			let cell = this.getCellWithMinorDistance(queue, "pathIndex");
			let validNeighbors = this.getLocalValidNeighbors(cell, prop, cellsBlock);
			let toRem = [];
			let toAdd = [];
			for (let x = 0; x < validNeighbors.length; x++) {
				cellNear = validNeighbors[x];
				let alt = cell.pathIndex + 1;
				if (alt < cellNear.pathIndex) {
					cellNear.pathIndex = alt;
					cellNear.previous = cell;
					toRem.push(this.findCellNearIndex(cellNear, queue));
					toAdd.push(cellNear);
					if (cellNear.id === end.id) {
						lCondExit = true;
						break;
					}
				}
			}

			toRem.sort(function (a, b) {
				return b - a;
			});

			for (let x = 0; x < toRem.length; x++) {
				queue.splice(toRem[x], 1);
			}

			for (let x = 0; x < toAdd.length; x++) {
				this.addOrdered(toAdd[x], queue, "pathIndex");
			}

			if (queue.length === 0) {
				lOkay = true;
				lCondExit = true;
			}
			fuse++;
			if (fuse > MazeConst.FUSE_DIJKSTRA) {
				lCondExit = true;
			}
		}

		if (!lOkay) {
			requestAnimationFrame(this.localPathFindBlock.bind(this, start, end, cellsBlock, prop, queue, callback));
		} else {
			this.localPathFound(start, end, cellsBlock, prop, callback);
		}

	}

	getLocalValidNeighbors(cell, prop, cellsBlock) {
		let neighbors = new Array();

		//console.log(cell)
		let n = this.getLocalNearbyCell(cell, cellsBlock, prop, Maze.DIR_N);
		let w = this.getLocalNearbyCell(cell, cellsBlock, prop, Maze.DIR_W);
		let s = this.getLocalNearbyCell(cell, cellsBlock, prop, Maze.DIR_S);
		let e = this.getLocalNearbyCell(cell, cellsBlock, prop, Maze.DIR_E);

		if (n) {
			if (!n.isWall()) {
				neighbors.push(n);
			}
		}
		if (w) {
			if (!w.isWall()) {
				neighbors.push(w);
			}
		}
		if (s) {
			if (!s.isWall()) {
				neighbors.push(s);
			}
		}
		if (e) {
			if (!e.isWall()) {
				neighbors.push(e);
			}
		}
		return neighbors;
	}

	getLocalNearbyCell(cell, cellsBlock, prop, dir) {
		let newCell = null;
		let pos = this.getLocalPosition(cell, prop);
		pos = this.movePosition(pos, dir);
		newCell = this.getLocalCell(pos, cellsBlock);
		return newCell;
	}

	getLocalPosition(cell, prop) {
		return { row: cell[prop + "Row"], col: cell[prop + "Col"] };
	}

	getLocalCell(pos, cellsBlock) {

		let cols = cellsBlock[pos.row];
		if (Pqp.isNullOrEmpty(cols)) {
			return null;
		}
		let cell = cols[pos.col];
		if (Pqp.isNullOrEmpty(cell)) {
			return null;
		}
		return cell;
	}

	localPathFound(start, cell, cellsBlock, prop, callback) {
		let path = new Array();
		let lCondExit = false;
		let fuse = 0;

		while (!lCondExit) {
			let prev = cell.previous;
			path.unshift(cell);
			cell = prev;
			if (Pqp.isNullOrEmpty(cell)) {
				lCondExit = true;
			} else {
				if (cell.id === start.id) {
					lCondExit = true;
				}
			}
			fuse++;
			if (fuse > MazeConst.FUSE_FIND_PATH) {
				lCondExit = true;
			}
		}
		for (let row = 0; row < cellsBlock.length; row++) {
			for (let col = 0; col < cellsBlock[row].length; col++) {
				delete cellsBlock[row][col][prop + "Row"];
				delete cellsBlock[row][col][prop + "Col"];
			}
		}


		if (callback) {
			callback.call(null, path);
		} else {
			console.log(path);
		}
	}

	saveStruct(tileMap, featurer) {
		let save = Saver.save(this, tileMap, featurer);
		if (!Game.PROD) {
			console.log(save);
		}
		let savestr = new Object();
		savestr.save = JSON.stringify(save);
		if (!Game.PROD) {
			console.log(savestr);
		}

		if (save.featurer.gameLevel !== 0) {
			window.localStorage.setItem("savegame", savestr.save);
		}
		//console.log(window.localStorage.getItem("savegame"));
		return savestr;
	}





}

Maze.ENUM = 0;
Maze.ID_POI = 0;

Maze.DIR_N = "n";
Maze.DIR_E = "e";
Maze.DIR_S = "s";
Maze.DIR_W = "w";
Maze.DIR_NW = "nw";
Maze.DIR_NE = "ne";
Maze.DIR_SW = "sw";
Maze.DIR_SE = "se";


Maze.EVENT_MAZE_READY = "eventMazeReady";
Maze.EVENT_CREATING_ROOM = "eventCreatingRoom";
Maze.EVENT_CREATE_PATH_BLOCK = "eventCreatePathBlock";
Maze.EVENT_PATH_CREATED = "eventPathCreated";
Maze.EVENT_CHECKING_ROOM = "eventCheckingRoom";
Maze.EVENT_FIXING_ROOM_WALLS = "eventFixingRoomWalls";
Maze.EVENT_SETTING_UNREACHABLE_CELLS_AS_WALL = "settingUnreachableCelsAsWall";
Maze.EVENT_CHECK_FOR_UNREACHABLE_ROOMS = "checkForUnreachableRooms";
Maze.EVENT_LOOKING_FOR_ROOM_DOORS = "eventLookingForRoomDoors";
Maze.EVENT_DIJKSTRA = "eventDijkstra";
Maze.EVENT_DIJKSTRA_COMPLETED = "eventDijkstraCompleted";
Maze.EVENT_FINDING_PATH = "eventFindingPath";
Maze.EVENT_PATH_FOUND = "eventPathFound";
Maze.EVENT_LOOKING_FOR_DEAD_ENDS = "eventLookingForDeadEnds";
Maze.EVENT_COMPUTING_POI = "eventComputingPOI";
Maze.EVENT_MOVE_ROOM_DOORS = "eventMoveRoomDoor";
Maze.EVENT_NEED_REBUILD = "eventNeedRebuild";

Maze.STATIC_TYPE_COLUMN = "typeColumn";
Maze.STATIC_TYPE_DOOR = "typeDoor";
Maze.STATIC_TYPE_CHEST = "typeChest";
Maze.STATIC_TYPE_FIREPLACE = "typeFireplace";
